import { render, staticRenderFns } from "./AssignHeroImageToRestaurant.vue?vue&type=template&id=11e97b91&scoped=true"
import script from "./AssignHeroImageToRestaurant.vue?vue&type=script&lang=js"
export * from "./AssignHeroImageToRestaurant.vue?vue&type=script&lang=js"
import style0 from "./AssignHeroImageToRestaurant.vue?vue&type=style&index=0&id=11e97b91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e97b91",
  null
  
)

export default component.exports